<template>
  <main class="main profile-page sell-offers-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="profile-top">
            <div class="title title-24">
              <b>{{ $t('My offers') }}</b>
            </div>
            <button v-if="$parent.offerEnabled" class="button" @click="$parent.openSaleSkinModal">
              <span>{{ $t('Sell skins') }}</span>
            </button>
          </div>
          <div class="profile-table" v-if="$parent.offerHistory && $parent.offerHistory.length">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>{{ $t('ID') }}</td>
                      <td>{{ $t('Date') }}</td>
                      <td>{{ $t('Skin name') }}</td>
                      <td>{{ $t('Status') }}</td>
                      <td>{{ $t('Total') }}</td>
                      <td>{{ $t('Details') }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in $parent.offerHistory" :key="i">
                      <td>{{ item.id }}</td>
                      <td>{{ $parent.formatDate(item.date_time) }}</td>
                      <td>{{ item.title }}</td>
                      <td :class="statusClass(item.status)">
                        <span class="status">{{ formatStatus(item.status) }}</span>
                      </td>
                      <td class="desc">
                        <b>{{ item.service_price || item.user_price }} {{ item.currency }}</b>
                      </td>
                      <td>
                        <a
                          class="offer-modal-open desc link"
                          v-if="item.status === 'offer'"
                          @click="openOfferDetails(item)"
                        >
                          <b>{{ $t('View') }}</b>
                        </a>
                        <a
                          class="offer-modal-open desc link"
                          v-if="item.status === 'ready_for_payout'"
                          @click="openAcceptOffer(item)"
                        >
                          <b>{{ $t('Withdraw') }}</b>
                        </a>
                        <span v-if="!['offer', 'ready_for_payout'].includes(item.status)" class="desc">-</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
          <div v-else-if="$parent.offerHistory && $parent.offerHistory.length === 0" class="desc" style="margin-top: 24px;">
            {{ $t('You don\'t have any offers yet. Click "Sell skins" to create your first offer.') }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'SellOffers',
  mounted() {
    if (!this.$parent.offerEnabled) {
      this.$router.push('/profile');
    }
  },
  methods: {
    formatStatus(status) {
      if (!status) return '';
      return status.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
    },
    statusClass(status) {
      switch (status) {
        // Green: User can take action (good states)
        case 'offer':
        case 'ready_for_payout':
          return 'green';
        // Orange: Warning/Info states
        case 'awaiting_item':
        case 'payout_processing':
          return 'orange';
        // Red: Error/Declined states
        case 'declined_by_user':
        case 'declined_by_service':
          return 'red';
        // Blue: Success/Completed
        case 'approved':
          return 'blue';
        // Gray: Pending (default)
        case 'pending':
        default:
          return 'gray';
      }
    },
    openOfferDetails(item) {
      this.$parent.openOfferDetailsModal(item);
    },
    openAcceptOffer(item) {
      this.$parent.openAcceptOfferModal(item);
    },
  },
};
</script>
<style scoped>
.profile-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.status {
  text-transform: capitalize;
}

td.green {
  color: #0CBE19 !important;
}

td.red {
  color: #E10473 !important;
}

td.orange {
  color: #FC7915 !important;
}

td.blue {
  color: #2196f3 !important;
}

td.gray {
  color: #AAABB6 !important;
}

.link {
  cursor: pointer;
  text-decoration: underline;
}

.link:hover {
  opacity: 0.8;
}
</style>